module.exports.cleric = {
  vi: {
    title: 'Giáo sĩ (Cleric) trong Avalon: kiểm tra phe và Ám sát',
    description:
      'Giáo sĩ hoạt động thế nào trong Avalon? Tìm hiểu lúc kiểm tra Đội trưởng Nhiệm vụ đầu, vì sao kết quả phe có thể gây hiểu lầm và cách Ám sát Giáo sĩ.',
    keywords: ['Giáo sĩ', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Clérigo em Avalon: lealdade e assassinato',
    description:
      'Como funciona o Clérigo em Avalon? Veja a lealdade do primeiro líder, as exceções de Trapaceiro e Encrenqueiro e a condição de assassinato.',
    keywords: ['Clérigo', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Cleric in Avalon: Loyalty Check & Assassination',
    description:
      'How does the Cleric work in Avalon? Learn when the first mission leader is checked, why loyalty can be misleading and how the Cleric assassination works.',
    keywords: ['Cleric', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Клирик в Авалоне: проверка лидера и убийство',
    description:
      'Как работает Клирик в Авалоне: проверка лидера первой миссии, исключения Трикстера и Траблмейкера, условия убийства и примеры игры.',
    keywords: ['Клирик', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆牧師：首任任務隊長查驗與刺殺',
    description: '阿瓦隆牧師查驗誰？了解第一次任務隊長的陣營查驗、騙子和麻煩友帶來的例外，以及本站牧師的刺殺條件。',
    keywords: ['牧師', '角色', '規則', '攻略'],
  },
  'zh-CN': {
    title: '阿瓦隆牧师：首任任务队长查验与刺杀',
    description: '阿瓦隆牧师查验谁？了解第一次任务队长的阵营查验、骗子和麻烦友带来的例外，以及本站牧师的刺杀条件。',
    keywords: ['牧师', '角色', '规则', '建议'],
  },
  es: {
    title: 'Clérigo en Avalon: lealtad y asesinato',
    description:
      '¿Cómo funciona el Clérigo en Avalon? Revisa la lealtad del primer líder, las excepciones de Tramposo y Problematizador y la condición de asesinato.',
    keywords: ['Clérigo', 'Rol', 'Reglas', 'Consejos'],
  },
};
